import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './account/login/login.component';
import { TokenLoginComponent } from './account/token-login/token-login.component';
import { SignUpComponent } from './account/signup/signup.component';
import { ResetPasswordComponent } from './account/resetpassword/resetpassword.component';
import { ConfirmEmailComponent } from './account/confirmemail/confirmemail.component';
import { PageNotFoundComponent } from './shared/not-found/not-found.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { DriverLayoutComponent } from './layouts/driver-layout/driver-layout.component';
import { RecordkeeperLayoutComponent } from './layouts/recordkeeper-layout/recordkeeper-layout.component';
import { HelpComponent } from './system/help/help.component';

import { AdminGuard, DriverGuard, RecordKeeperGuard } from './guards/index';

export const appRoutes: Routes = [
    { path: 'login', component: LoginComponent},
    { path: 'signup', component: SignUpComponent},
    { path: 'resetpassword', component: ResetPasswordComponent},
    { path: 'confirmemail', component: ConfirmEmailComponent},
    { path: 'help', component: HelpComponent},
    {
        path: 'admin',
        component: AdminLayoutComponent,
        data: { title: 'Admin' },
        children: [
            {
                path: '',
                loadChildren: './admin/admin.module#AdminModule'
            }
        ],
        canActivate: [AdminGuard]
    },
    {
        path: 'driver',
        component: DriverLayoutComponent,
        data: { title: 'Driver' },
        children: [
            {
                path: '',
                loadChildren: './driver/driver.module#DriverModule'
            }
        ],
        canActivate: [DriverGuard]
    },
    {
        path: 'recordkeeper',
        component: RecordkeeperLayoutComponent,
        data: { title: 'Record Keeper' },
        children: [
            {
                path: '',
                loadChildren: './recordkeeper/recordkeeper.module#RecordkeeperModule'
            }
        ],
        canActivate: [RecordKeeperGuard]
    },
    {
        path: 'tokenLogin',
        component: TokenLoginComponent
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule],
    // providers: [MatDialogRef, MAT_DIALOG_DATA]
})
export class AppRoutingModule { }
